import { render, staticRenderFns } from "./inputphone.vue?vue&type=template&id=45ef75fc&scoped=true"
import script from "./inputphone.vue?vue&type=script&lang=js"
export * from "./inputphone.vue?vue&type=script&lang=js"
import style0 from "./inputphone.vue?vue&type=style&index=0&id=45ef75fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef75fc",
  null
  
)

export default component.exports